import { Link } from 'react-router-dom';
import { Card, EmptyState } from '@/components/Card';

export function NotFoundPage() {
  return (
    <Card>
      <EmptyState
        title="页面不存在"
        description="链接可能已经失效，回到项目列表重新开始吧。"
        action={
          <Link
            to="/"
            className="inline-flex h-11 items-center rounded-md bg-accent px-5 text-sm font-medium text-accent-fg transition-colors hover:bg-accent-hover"
          >
            返回项目列表
          </Link>
        }
      />
    </Card>
  );
}
